const prices = [
  {
    price: 0,
    plan: "Basic",
    planName: "Subscriber",
    desc: "Author Newsletter",
    benefits: [
      { check: true, content: "1 ChatPoints per month" },
      { check: true, content: "Author updates" },
      { check: true, content: "Sexy chats" },
      { check: true, content: "Surprising conversations" },

      { check: false, content: "Exclusive short stories" },
      { check: false, content: "Read chapters as they're written" },
      { check: false, content: "Supporting the author" },
      { check: false, content: "Additional sexy characters" },
      { check: false, content: "Read the characters' full novels" },
      { check: false, content: "Chat with the characters as you read" },
      { check: false, content: "Characters have voices" },
    ],
  },
  // {
  //   price: 4.99,
  //   plan: "Starter",
  //   desc: "Just a Taste",
  //   benefits: [
  //     { check: true, content: "75 ChatPoints per month" },
  //     { check: true, content: "Basic conversations" },
  //     { check: false, content: "Genius-level chatbots" },
  //     { check: false, content: "Personality Mode" },
  //     { check: false, content: "Steamy chats" },
  //     { check: false, content: "Get advice" },
  //     { check: false, content: "Charming & Engaging conversations" },
  //     { check: false, content: "Chatbots have voices" },
  //   ],
  // },
  {
    price: 4.99,
    plan: "Plus",
    planName: "Patron",
    desc: "Full Access ",
    benefits: [
      { check: true, content: "75 ChatPoints per month" },
      { check: true, content: "Author updates" },
      { check: true, content: "Sexy chats" },
      { check: true, content: "Surprising conversations" },

      { check: true, content: "Exclusive short stories" },
      { check: true, content: "Read chapters as they're written" },
      { check: true, content: "Supporting the author" },
      { check: false, content: "Additional sexy characters" },
      { check: false, content: "Read the characters' full novels" },
      { check: false, content: "Chat with the characters as you read" },
      { check: false, content: "Characters have voices" },
    ],
  },
  {
    price: 14.99,
    plan: "Premium",
    planName: "Premium",
    desc: "All Characters, Stories, & Voices",
    benefits: [
      { check: true, content: "225 ChatPoints per month" },
      { check: true, content: "Author updates" },
      { check: true, content: "Sexy chats" },
      { check: true, content: "Surprising conversations" },

      { check: true, content: "Exclusive short stories" },
      { check: true, content: "Read chapters as they're written" },
      { check: true, content: "Supporting the author" },
      { check: true, content: "Additional sexy characters" },
      { check: true, content: "Read the characters' full novels" },
      { check: true, content: "Chat with the characters as you read" },
      { check: true, content: "Characters have voices" },
    ],
  },
];
export default prices;
